export default __webpack_public_path__ + "static/media/control.a5f1e707.png";